/*
What a client does with a socket.io namespace `connect_error`, shared by the
round socket (`ImperativeState.ts`) and the engine socket
(`event-sourcing/engineConnection.ts`). Pure, so the policy is unit-tested
without a live socket.
*/

/**
 * Namespace-level rejections from the server's socket auth middleware.
 * Retrying these with the same credentials cannot succeed; everything else a
 * namespace can reject with is treated as transient.
 */
export function isSessionRejection(message: string): boolean {
  return message === "NO_COOKIE" || message === "NO_USER_ID";
}

/**
 * Backoff for manually retrying a transient namespace rejection. Socket.IO
 * does NOT retry these on its own — the manager considers the engine-level
 * connection successful, so a rejected namespace is simply left dead.
 * Returns null when out of attempts (attempt is 1-based).
 */
export function connectErrorRetryDelayMs(attempt: number): number | null {
  return attempt >= 1 && attempt <= 4 ? attempt * 3000 : null;
}
